interface FooterProps {
  profile?: {
    full_name: string;
  } | null;
}

export const Footer = ({ profile }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border py-8">
      <div className="max-w-6xl mx-auto container-padding">
        <p className="text-center text-sm text-muted-foreground">
          © {currentYear} {profile?.full_name || "Resume"}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
